import { render, staticRenderFns } from "./UpdateHomeBanner.vue?vue&type=template&id=486314bb"
import script from "./UpdateHomeBanner.vue?vue&type=script&lang=js"
export * from "./UpdateHomeBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports